<template>
  <router-view
    :inquiry="inquiry"
    @update-inquiry-data="updateInquiryData"
  ></router-view>
</template>

<script>
import { defineComponent, reactive } from "vue";

export default defineComponent({
  setup() {
    const url = new URL(location.href);

    let serviceName = "linkus";
    if (url.searchParams.has("serviceName")) {
      serviceName = url.searchParams.get("serviceName");
    }

    let inquiryType = "";
    if (url.searchParams.has("inquiryType")) {
      inquiryType = url.searchParams.get("inquiryType");
    }

    const inquiry = reactive({
      companyName: "",
      name: "",
      nameKana: "",
      phoneNumber: "",
      email: "",
      inquiryType,
      notes: "",
      serviceName,
    });

    const updateInquiryData = ($event) => {
      Object.assign(inquiry, $event);
    };

    return {
      inquiry,
      updateInquiryData,
    };
  },
});
</script>
